<!--
 * @Description: 排考 非统一时间 设置
 * @Author: PF
 * @Date: 2023-04-23 16:15:37
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:38:01
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openSzFty" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">设置</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="ruleForm={};closeWindow('openSzFty', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="title mb20">{{kcmc}} 考场</div>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="97px">
        <el-row :gutter="20" class="wp100 mb10">
          <el-col :span="24">
            <el-form-item label="设置考试地点">
              <!-- 单选 BEGIN -->
              <div class="an-niu wp100" style="display: flex; align-items: center;">
                <el-button type="primary" class="w180" @click="openkscdDuoTiao=true">选择</el-button>
                <el-button class="ml10 mr10" link v-if="ruleForm.kcddmc" @click="ruleForm.kcddmc='';ruleForm.kcddid=''">清空</el-button>
                  <el-tag v-if="ruleForm.kcddmc" :disable-transitions="false">
                    {{ ruleForm.kcddmc }}
                  </el-tag>
              </div>
              <!-- 单选 END -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="容纳考生人数" prop="rnrs">
              <div class="w180">
                <el-input-number v-model="ruleForm.rnrs" :min="1" />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <div class="mb5">设置监考老师</div>
        <div class="jkjs-list" v-for="(item,index) in listKmccJkjs" :key="item.ccs">
          <div class="jkjs-nr w80">第{{item.ccs}}场</div>
          <div class="jkjs-nr w100"><el-input placeholder="开始考号" v-model="item.qskh" /></div>
          <div class="jkjs-nr w100"><el-input placeholder="结束考号" v-model="item.jskh" /></div>
          <div class="jkjs-nr w150">{{ item.kskmmc }}</div>
          <div class="jkjs-nr w100"><el-button type="primary" class="wp100" @click="xuanXeJiaoShi(item, index)">选择</el-button></div>
          <div class="jkjs-nr w">
            <span v-for="(val, i) in item.jzgxm" :key="i">
              <span v-if="i>0">、</span>
              <span>{{val}}</span>
            </span>
          </div>
        </div>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="ruleForm={};closeWindow('openSzFty', emits, false)">取消</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <jiaozhigongduotiao v-if="openDuoTiao" v-model:openDuoTiao="openDuoTiao" :row="tcRow" @ReturnData="jzgReturnData" />
  <jiaoxuechangdidantiao v-if="openkscdDuoTiao" v-model:openDanTiao="openkscdDuoTiao" :row="tcRow" @ReturnData="kcddReturnData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import jiaozhigongduotiao from '@/components/chazhaodaihui/jiaozhigongduotiao'
import jiaoxuechangdidantiao from '@/components/chazhaodaihui/jiaoxuechangdidantiao'

const props = defineProps({
  openSzFty: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openSzFty', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({ rnrs: 0 })

const row = ref()
const kcmc = ref()

// 提交
const submit = async () => {
  ruleForm.value.menuId = sessionStorage.getItem('menuId')
  ruleForm.value.listKmccJkjs = listKmccJkjs.value.map((item) => ({
    jsid: item.jzgid,
    ccid: item.ccid,
    qskh: item.qskh,
    jskh: item.jskh
  }))
  const o = {
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/shezhifeitongyikaoshididianjiankaojiaoshi',
    data: ruleForm.value
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      closeWindow('openSzFty', emits, true)
      ruleForm.value = {}
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const listKmccJkjs = ref([])
watch(
  () => props.openSzFty,
  () => {
    if (props.openSzFty) {
      row.value = props.row
      listKmccJkjs.value = props.row.listKmcc || []
      listKmccJkjs.value.sort((a, b) => {
        return a.ccs - b.ccs
      })
      listKmccJkjs.value.map(item => {
        item.jzgid = item.listJkjs.map((val) => val.jsid)
        item.jzgxm = item.listJkjs.map((val) => val.jsxm)
        return item
      })
      kcmc.value = props.row.kch || ''
      ruleForm.value.kcid = props.row.id || ''
      ruleForm.value.kcddid = props.row.kcddid
      ruleForm.value.kcddmc = props.row.kccdmc
      ruleForm.value.rnrs = props.row.rnksrs
    }
  },
  { deep: true, immediate: true }
)
// 选择考试场地
const openkscdDuoTiao = ref(false)
const kcddReturnData = (data) => {
  ruleForm.value.kcddid = data.id
  ruleForm.value.kcddmc = data.jsmc
}
// 选择监考考教师
const tcRow = ref()
const dangQain = ref()
const openDuoTiao = ref(false)
const xuanXeJiaoShi = (item, index) => {
  dangQain.value = index
  tcRow.value = { ids: item.jzgid }
  openDuoTiao.value = true
}
const jzgReturnData = (item) => {
  listKmccJkjs.value[dangQain.value].jzgid = item.map((val) => val.id)
  listKmccJkjs.value[dangQain.value].jzgxm = item.map((val) => val.xm)
}
</script>

<style lang="less" scoped>
.title {
  font-size: 18px;
  font-weight: 600;
}
.jkjs-list {
  width: 100%;
  display: flex;
  align-items: center;
  .jkjs-nr + .jkjs-nr {
    margin-left: 10px;
  }
  .jkjs-nr {
    margin-bottom: 10px;
  }
}
</style>
